/**
 * Troca o Pokémon principal por uma reserva sem perder nenhum dado dos dois.
 * O id pertence ao slot da coleção: o antigo principal ocupa esse slot e o
 * promovido passa a ser o objeto ativo, que não usa id no runtime atual.
 */
export function promoteReservePokemon(active, reserve, { activeMaxHp, reserveMaxHp } = {}) {
  if (!active || !reserve || reserve.id == null) return null;
  const oldActiveMax = Math.max(1, Number(activeMaxHp) || Number(active.stats?.hp) || Number(active.currentHp) || 1);
  const promotedMax = Math.max(1, Number(reserveMaxHp) || Number(reserve.stats?.hp) || 1);
  const oldActiveCurrent = Math.max(0, Math.min(oldActiveMax, Number(active.currentHp) || 0));
  const reserveRatio = Math.max(0, Math.min(1, Number(reserve.hp ?? 100) / 100));
  const promotedCurrent = reserve.currentHp == null
    ? Math.round(promotedMax * reserveRatio)
    : Math.max(0, Math.min(promotedMax, Number(reserve.currentHp) || 0));

  const nextReserve = {
    ...active,
    id: reserve.id,
    hp: Math.round(oldActiveCurrent / oldActiveMax * 100),
  };
  delete nextReserve.currentHp;

  const nextActive = {
    ...reserve,
    currentHp: promotedCurrent,
    // Mantém UUID do servidor no parceiro (promote apaga id local da box).
    serverId: reserve.serverId || reserve.id,
  };
  delete nextActive.id;
  delete nextActive.hp;

  if (active.serverId || active.id) {
    nextReserve.serverId = active.serverId || active.id;
  }

  return { active: nextActive, reserve: nextReserve };
}
